<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title base-index-title">{{ title }}</h4>
          <md-card-actions class="text-right md-alignment-right">
          </md-card-actions>
        </md-card-header>
        <md-card-content>
          <base-search-form
            :formSearch="formSearch"
            @search="changePage"
            :enableExport="enableExport"
          />
          <university-template-table
            :tableData="tableData"
            :pagination="pagination"
            :columns="columns"
            :hideAction="hideAction"
          />
        </md-card-content>
        <base-pagination :pagination="pagination" @changePage="changePage" />
      </md-card>
    </div>
  </div>
</template>

<script>
import { BasePagination, BaseSearchForm } from "@/components/Base/index.js";

import formatDateTime from "@/core/utils/formatTime";
import { UniversityTemplateService } from "../../../services/universityTemplate.service";
import UniversityTemplateTable from "./UniversityTemplateTable";

export default {
  name: "UniversityTemplateIndex",
  data() {
    return {
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 0
      },
      tableData: [],
      params: {},
      modal: {
        show: false,
        action: "view"
      },
      modalAdd: {
        show: false
      }
    };
  },
  props: [
    "path",
    "formSearch",
    "columns",
    "enableExport",
    "title",
    "hideAction",
    "serviceName"
  ],
  components: { UniversityTemplateTable, BasePagination, BaseSearchForm },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      const response = await new UniversityTemplateService().getList(
        this.params
      );

      let tableData = response.data;
      tableData.forEach(function(universityTemplate) {
        universityTemplate.university_division_name =
          universityTemplate.university_division.name;
        universityTemplate.university_type_name =
          universityTemplate.university_type.name;
        universityTemplate.created_at = universityTemplate.created_at
          ? formatDateTime(universityTemplate.created_at)
          : "";
        universityTemplate.updated_at = universityTemplate.updated_at
          ? formatDateTime(universityTemplate.updated_at)
          : "";
      });
      this.tableData = tableData;
      this.pagination.perPage = response.per_page;
      this.pagination.currentPage = response.current_page;
      this.pagination.total = response.total;
      this.pagination.from = response.from;
      this.pagination.to = response.to;
      return this.tableData;
    },
    changePage(params) {
      this.params.page = this.pagination.currentPage;
      this.params.limit = this.pagination.perPage;
      this.params = { ...this.params, ...params };
      this.getTableData();
    },
    closeModal() {
      this.modal.show = false;
      this.modalAdd.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    notify(message, type = "success", title = "Notification") {
      this.$notify({
        message: message,
        type: type,
        title: title,
        text: message
      });
    }
  },
  computed: {
    currentRoutePath() {
      return this.$route.path;
    }
  }
};
</script>
<style scoped>
.md-card .md-card-actions {
  border: none;
  margin-top: 15px;
}
</style>
